import { useEffect } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { LayoutDashboard, FileText, Users, Mail, Building2, MessageSquare, LogOut, Globe2, Newspaper, LayoutGrid, TrendingUp, Swords, ClipboardList } from "lucide-react";

const NAV = [
  { name: "Dashboard", href: "/admin", icon: LayoutDashboard },
  { name: "Newsroom", href: "/admin/newsroom", icon: Newspaper },
  { name: "Topic Ideas", href: "/admin/topic-ideas", icon: TrendingUp },
  { name: "Competitor Gaps", href: "/admin/competitor-gaps", icon: Swords },
  { name: "Briefs", href: "/admin/briefs", icon: ClipboardList },
  { name: "Articles", href: "/admin/articles", icon: FileText },
  { name: "Categories", href: "/admin/categories", icon: LayoutGrid },
  { name: "Contractors", href: "/admin/contractors", icon: Building2 },
  { name: "Discussions", href: "/admin/discussions", icon: MessageSquare },
  { name: "Markets", href: "/admin/markets", icon: Globe2 },
  { name: "Leads", href: "/admin/leads", icon: Users },
  { name: "Subscribers", href: "/admin/subscribers", icon: Mail },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user === false) navigate("/admin/login");
  }, [user, navigate]);

  if (user === null || user === false) return <div className="py-24 text-center text-slate-400">Loading...</div>;

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-slate-50" data-testid="admin-layout">
      <aside className="w-56 bg-navy text-white flex flex-col">
        <div className="p-5 border-b border-white/10">
          <p className="font-serif-heading font-bold text-lg">HouseTalk <span className="text-gold">Admin</span></p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              data-testid={`admin-nav-${item.name.toLowerCase()}`}
              className={`flex items-center gap-2 px-3 py-2 rounded text-sm font-medium transition-colors ${location.pathname === item.href ? "bg-gold text-navy" : "text-white/80 hover:bg-white/10"}`}
            >
              <item.icon className="w-4 h-4" /> {item.name}
            </Link>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={handleLogout} data-testid="admin-logout-button" className="flex items-center gap-2 px-3 py-2 rounded text-sm font-medium text-white/80 hover:bg-white/10 w-full">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
